<template>
    <div class="banner">
        <img :src="`${showImgUrl}${bannerData.appBanner}`" alt="">
        <div class="banner-title">
            <h1>{{bannerData.name}}</h1>
            <p>开始时间：{{bannerData.startTime}}</p>
            <p>结束时间：{{bannerData.endTime}}</p>
            <p>{{bannerData.province}} · {{bannerData.city}} · {{bannerData.address}}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['bannerData'],
    data () {
        return {
            showImgUrl: process.env.VUE_APP_SHOW_IMGURL
        }
    }
}
</script>
<style lang="stylus" scoped>
    .banner
        display flex
        justify-content space-between
        padding 20px
        background #fff
        max-height 240px
        overflow hidden
        img
            width 273px
            max-height 240px
        .banner-title
            width 416px
            text-align justify
            color #333
            h1
                font-size 32px
                margin-bottom 10px
            p
                font-size 20px
    @media screen and (min-width: 800px)
            .banner
                display flex
                justify-content space-between
                padding 20px
                background #fff
                border-bottom 1px solid #646464
                max-height 200px
                overflow hidden
                img
                    width 332px
                    max-height 180px
                .banner-title
                    width 526px
                    text-align justify
                    color #333
                    h1
                        font-size 28px
                        margin-bottom 10px
                    p
                        font-size 24px
</style>